import angular from 'angular'
import './affiliates.service'
import './edit/edit.controller'

angular
  .module('admin.affiliates', ['admin.affiliates.edit', 'admin.affiliates.service'])
  .controller('AffiliatesCtrl', AffiliatesCtrl)

/** @ngInject */
function AffiliatesCtrl(
  $scope,
  $state,
  $timeout,
  $stateParams,
  AffiliatesService,
  ChannelGroupChildrenService,
) {
  var vm = this
  vm.itemsPending = []
  vm.itemsApproved = []
  vm.itemsRejected = []
  vm.channels = []

  function reloadPaginationPending() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationApproved() {
    vm.totalUsers2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationRejected() {
    vm.totalUsers3 = 0
    vm.oldPage3 = 0
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  vm.afspTypes = [
    {
      id: 1,
      name: 'Facebook',
    },
    {
      id: 2,
      name: 'Twitter',
    },
    {
      id: 3,
      name: 'Instagram',
    },
    {
      id: 4,
      name: 'Website',
    },
    {
      id: 5,
      name: 'Tiktok',
    },
  ]

  var tab = localStorage.getItem('tabaffiliate')
  if (tab !== null) {
    if (tab === 'pending') {
      $('#approved').removeClass('active')
      $('#rejected').removeClass('active')
      $('#pending').addClass('active')
      $('#pendingtab').addClass('active')
    } else if (tab === 'approved') {
      $('#pending').removeClass('active')
      $('#rejected').removeClass('active')
      $('#approved').addClass('active')
      $('#approvedtab').addClass('active')
    } else if (tab === 'rejected') {
      $('#pending').removeClass('active')
      $('#approved').removeClass('active')
      $('#rejected').addClass('active')
      $('#rejectedtab').addClass('active')
    }
  } else {
    $('#pending').addClass('active')
    $('#pendingtab').addClass('active')
  }

  reloadPaginationPending()
  reloadPaginationApproved()
  reloadPaginationRejected()

  loadPending(1)
  loadApproved(1)
  loadRejected(1)

  ChannelGroupChildrenService.listChannel().then(function (result) {
    vm.channels = result.results
  })

  function loadPending(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    AffiliatesService.listPending(vm.oldPage, vm.currentPage).then(function (result) {
      var items = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < items.length; i++) {
        items[i].fav = ''
        if (items[i].afsp === undefined) {
          items[i].afsp = []
        } else {
          for (var j = 0; j < items[i].afsp.length; j++) {
            items[i].afsp[j].editing = false
            switch (items[i].afsp[j]['k']) {
              case 1:
                items[i].afsp[j].type = 'Facebook'
                break
              case 2:
                items[i].afsp[j].type = 'Twitter'
                break
              case 3:
                items[i].afsp[j].type = 'Instagram'
                break
              case 4:
                items[i].afsp[j].type = 'Website'
                break
              case 5:
                items[i].afsp[j].type = 'Tiktok'
              default:
                break
            }
          }
        }
        if (items[i].afch === undefined) {
          items[i].afch = []
        } else {
          for (var j = 0; j < items[i].afch.length; j++) {
            items[i].afch[j].editing = false
          }
        }

        items[i].fav = updateFavoriteAffiliate(items[i])

        switch (items[i].k) {
          case 0:
            items[i].type = 'Social Influencer'
            break
          case 1:
            items[i].type = 'Blogger'
            break
          case 2:
            items[i].type = 'Website'
            break
          case 3:
            items[i].type = 'Email'
            break
          case 4:
            items[i].type = 'Retail Partner'
            break
          case 5:
            items[i].type = 'Licensor'
            break
          case 6:
            items[i].type = 'Conference'
            break
          case 7:
            items[i].type = 'Friend'
            break
          case 8:
            items[i].type = 'Other'
            break
          default:
            break
        }
      }

      vm.itemsPending = items
    })
  }

  function loadApproved(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    AffiliatesService.listApproved(vm.oldPage2, vm.currentPage2).then(function (result) {
      var items = result.results
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }

      for (var i = 0; i < items.length; i++) {
        items[i].fav = ''
        if (items[i].afsp === undefined) {
          items[i].afsp = []
        } else {
          for (var j = 0; j < items[i].afsp.length; j++) {
            items[i].afsp[j].editing = false
            switch (items[i].afsp[j]['k']) {
              case 1:
                items[i].afsp[j].type = 'Facebook'
                break
              case 2:
                items[i].afsp[j].type = 'Twitter'
                break
              case 3:
                items[i].afsp[j].type = 'Instagram'
                break
              case 4:
                items[i].afsp[j].type = 'Website'
                break
              case 5:
                items[i].afsp[j].type = 'Tiktok'
              default:
                break
            }
          }
        }
        if (items[i].afch === undefined) {
          items[i].afch = []
        } else {
          for (var j = 0; j < items[i].afch.length; j++) {
            items[i].afch[j].editing = false
          }
        }

        items[i].fav = updateFavoriteAffiliate(items[i])

        switch (items[i].k) {
          case 0:
            items[i].type = 'Social Influencer'
            break
          case 1:
            items[i].type = 'Blogger'
            break
          case 2:
            items[i].type = 'Website'
            break
          case 3:
            items[i].type = 'Email'
            break
          case 4:
            items[i].type = 'Retail Partner'
            break
          case 5:
            items[i].type = 'Licensor'
            break
          case 6:
            items[i].type = 'Conference'
            break
          case 7:
            items[i].type = 'Friend'
            break
          case 8:
            items[i].type = 'Other'
            break
          default:
            break
        }
      }

      vm.itemsApproved = items
    })
  }

  function loadRejected(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first3) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage3 - 25
    } else {
      vm.first3 = false
    }

    AffiliatesService.listRejected(vm.oldPage3, vm.currentPage3).then(function (result) {
      var items = result.results
      if (vm.totalItems3 === 0) {
        vm.totalItems3 = result.ct
      }

      for (var i = 0; i < items.length; i++) {
        items[i].fav = ''
        if (items[i].afsp === undefined) {
          items[i].afsp = []
        } else {
          for (var j = 0; j < items[i].afsp.length; j++) {
            items[i].afsp[j].editing = false
            switch (items[i].afsp[j]['k']) {
              case 1:
                items[i].afsp[j].type = 'Facebook'
                break
              case 2:
                items[i].afsp[j].type = 'Twitter'
                break
              case 3:
                items[i].afsp[j].type = 'Instagram'
                break
              case 4:
                items[i].afsp[j].type = 'Website'
                break
              case 5:
                items[i].afsp[j].type = 'Tiktok'
              default:
                break
            }
          }
        }
        if (items[i].afch === undefined) {
          items[i].afch = []
        } else {
          for (var j = 0; j < items[i].afch.length; j++) {
            items[i].afch[j].editing = false
          }
        }

        items[i].fav = updateFavoriteAffiliate(items[i])

        switch (items[i].k) {
          case 0:
            items[i].type = 'Social Influencer'
            break
          case 1:
            items[i].type = 'Blogger'
            break
          case 2:
            items[i].type = 'Website'
            break
          case 3:
            items[i].type = 'Email'
            break
          case 4:
            items[i].type = 'Retail Partner'
            break
          case 5:
            items[i].type = 'Licensor'
            break
          case 6:
            items[i].type = 'Conference'
            break
          case 7:
            items[i].type = 'Friend'
            break
          case 8:
            items[i].type = 'Other'
            break
          default:
            break
        }
      }

      vm.itemsRejected = items
    })
  }

  vm.pageChangedPending = function (newPage) {
    loadPending(newPage)
  }

  vm.pageChangedApproved = function (newPage) {
    loadApproved(newPage)
  }

  vm.pageChangedRejected = function (newPage) {
    loadRejected(newPage)
  }

  vm.tabPending = function () {
    $('#approved').removeClass('active')
    $('#rejected').removeClass('active')
    $('#pending').addClass('active')
    localStorage.setItem('tabaffiliate', 'pending')
  }

  vm.tabApproved = function () {
    $('#pending').removeClass('active')
    $('#rejected').removeClass('active')
    $('#approved').addClass('active')
    localStorage.setItem('tabaffiliate', 'approved')
  }

  vm.tabRejected = function () {
    $('#pending').removeClass('active')
    $('#approved').removeClass('active')
    $('#rejected').addClass('active')
    localStorage.setItem('tabaffiliate', 'rejected')
  }

  vm.add = function () {
    $state.go('admin.affiliates.edit', { id: 0 })
  }

  vm.edit = function (item) {
    $state.go('admin.affiliates.edit', { id: item.id })
  }

  vm.approve = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          AffiliatesService.approved(item.id).then(
            function () {
              loadPending(1)
              loadApproved(1)
              loadRejected(1)
            },
            function (err) {
              $timeout(function () {
                swal(err.error.message, '', 'error')
              }, 250)
            },
          )
        }
      },
    )
  }

  vm.reject = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          AffiliatesService.rejected(item.id).then(function () {
            loadPending(1)
            loadApproved(1)
            loadRejected(1)
          })
        }
      },
    )
  }

  vm.openModalSocialProfile = function (item, type) {
    vm.typeAffiliate = type
    vm.affiliateSelected = item
    $('#myModalSocial').modal('show')
  }

  vm.addAfsp = function () {
    vm.affiliateSelected.afsp.push({
      id: 0,
      k: 0,
      url: '',
      editing: true,
    })
  }

  vm.saveAfsp = function (item) {
    item['id-aff'] = vm.affiliateSelected.id
    if (item.id === 0) {
      AffiliatesService.saveSocialProfile(item).then(
        function (result) {
          vm.affiliateSelected.afsp = updateTypeAfsp(vm.affiliateSelected.afsp)
          item.editing = !item.editing
          item.id = result.results.id
        },
        function () {
          swal('Already exist this social profile', '', 'error')
        },
      )
    } else {
      AffiliatesService.updateSocialProfile(item.id, item).then(
        function () {
          vm.affiliateSelected.afsp = updateTypeAfsp(vm.affiliateSelected.afsp)
          item.editing = !item.editing
        },
        function () {
          swal('Already exist this social profile', '', 'error')
        },
      )
    }
  }

  vm.editAfsp = function (item) {
    item.editing = !item.editing
  }

  vm.deleteAfsp = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          AffiliatesService.removeSocialProfile(item.id).then(function () {
            vm.affiliateSelected.afsp.remove(item)
          })
        }
      },
    )
  }

  vm.cancelAfsp = function (item) {
    item.editing = !item.editing
    vm.affiliateSelected.afsp.remove(item)
  }

  function updateTypeAfsp(data) {
    for (var i = 0; i < data.length; i++) {
      switch (data[i]['k']) {
        case 1:
          data[i].type = 'Facebook'
          break
        case 2:
          data[i].type = 'Twitter'
          break
        case 3:
          data[i].type = 'Instagram'
          break
        case 4:
          data[i].type = 'Website'
          break
        case 5:
          data[i].type = 'Tiktok'
          break
        default:
          break
      }
    }
    return data
  }

  vm.openModalFavorite = function (item, type) {
    vm.typeAffiliate = type
    vm.affiliateSelected = item
    $('#myModalFavorite').modal('show')
  }

  vm.addAfch = function () {
    vm.affiliateSelected.afch.push({
      id: 0,
      editing: true,
    })
  }

  vm.saveAfch = function (item) {
    if (item.id === 0) {
      swal('Required channel id', '', 'error')
      return
    }
    AffiliatesService.saveFavorite(vm.affiliateSelected.id, item.id).then(function (result) {
      vm.affiliateSelected.afch.remove(item)
      result.results.editing = false
      vm.affiliateSelected.afch.push(result.results)
      vm.affiliateSelected.afch = _.uniqBy(vm.affiliateSelected.afch, 'id')
      vm.affiliateSelected.fav = updateFavoriteAffiliate(vm.affiliateSelected)
    })
  }

  vm.deleteAfch = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          AffiliatesService.removeFavorite(vm.affiliateSelected.id, item.id).then(function () {
            vm.affiliateSelected.afch.remove(item)
            vm.affiliateSelected.afch = _.uniqBy(vm.affiliateSelected.afch, 'id')
            vm.affiliateSelected.fav = updateFavoriteAffiliate(vm.affiliateSelected)
          })
        }
      },
    )
  }

  vm.cancelAfch = function (item) {
    item.editing = !item.editing
    vm.affiliateSelected.afch.remove(item)
  }

  function updateFavoriteAffiliate(data) {
    data.fav = ''
    for (var i = 0; i < data.afch.length; i++) {
      data.fav += data.afch[i].t + ', '
    }
    return data.fav
  }
}
